import {
    FAILED_TO_RECEIVE_EXPENSE_TYPES, GET_EXPENSE_TYPES, RECEIVE_EXPENSE_TYPES,
    RECEIVE_EXPENSES_EDIT
} from "../actions";

const defaultState = {
    expenseTypes: [],
    fetching: false,
    responseMessage: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case RECEIVE_EXPENSES_EDIT:
            return {
                ...state,
                fetching: false,
                expenseTypes: action.payload.expenses
            };
        case GET_EXPENSE_TYPES:
            return {
                ...state,
                fetching: true
            };
        case RECEIVE_EXPENSE_TYPES:
            return {
                ...state,
                fetching: false,
                expenseTypes: action.payload.body
            };
        case FAILED_TO_RECEIVE_EXPENSE_TYPES:
            return {
                ...state,
                fetching: false
            };
        default:
            return state;
    }
};